export default __webpack_public_path__ + "static/media/public-safety-replay-keynote.en.59f23efe.vtt";